var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"sn-select-content",style:(_vm.containerWidth)},[(_vm.showClearButton)?_c('div',{staticClass:"clear-answer",class:{
      'small': !_vm.tall
    },on:{"click":_vm.optionCleared}},[_c('label',{domProps:{"textContent":_vm._s(_vm.$t('multiselect.select'))}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.optionList),function(option,index){return _c(_vm.optionTemplates[_vm.displayType],{key:index,tag:"component",class:{
      'small': !_vm.tall
    },attrs:{"option-data":option,"settings":_vm.optionSettings},on:{"optionSelected":_vm.optionSelected}})}),_vm._v(" "),(!_vm.hasOptions)?_c('div',{staticClass:"no-result",class:{
      'small': !_vm.tall
    }},[_c('label',{domProps:{"textContent":_vm._s(_vm.$t('multiselect.noResults'))}})]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b362af9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/SNSelectContent.vue
// module id = null
// module chunks = 